import React, { useContext } from "react";
import PreviewRequestPosDetailsBox from "../../../fragments/preview-fragment/PreviewFragment";
import { RavenGetValue, RavenNumberFormat } from "@ravenpay/raven-bank-ui";
import { formatTypeFunction } from "../../../helper";
import ActionContext from "../../../context/ActionContext";

interface MyComponentProps {
  details?: any;
}

const RequestTerminalPreview = ({ details }: MyComponentProps) => {
  const actionCtx = useContext(ActionContext);
  const defaultList = [
    {
      label: "Terminal Type",
      value: formatTypeFunction(details?.type),
      key: "",
    },
    { label: "Quantity", value: "", key: "quantity" },
    {
      label: "Delivery Type",
      value: formatTypeFunction(details?.deliveryMethod),
      key: "",
    },
    {
      label: "Pickup Days",
      value: "",
      key: "days",
    },
    { label: "State", value: "", key: "state?.value" },
    { label: "City", value: "", key: "city?.value" },
    { label: "Address", value: "", key: "streetAddress" },
  ];

  return (
    <>
      <PreviewRequestPosDetailsBox
        amount={
          RavenNumberFormat(
            details?.quantity * details?.pricePerOne ||
              actionCtx?.configDetails?.partnerInfo?.device_price
          ) as any
        }
        manualCompType
        manualList={RavenGetValue(defaultList, details)}
        details={details}
      />
    </>
  );
};

export default RequestTerminalPreview;
